import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "./Inspiration.scss";
import mask1 from "../Assests/Mask Group (5).png"
import mask2 from "../Assests/Mask Group (9).png"
import mask3 from  "../Assests/Mask Group (7).png"
import mask4 from "../Assests/Mask Group (8).png"

// Sample Data
const vehicleData = [
  { img: mask1, title: "Wedding Vehicles", description: "Perfect cars for your special day." },
  { img: mask2, title: "Business Vehicles", description: "Luxury vehicles for business trips." },
  { img: mask3 , title: "Quinceañera Vehicles", description: "Stylish rides for your celebration." },
  { img: mask4, title: "Birthday Vehicles", description: "Celebrate with the best ride!" },
  { img: mask3, title: "Birthday Vehicles", description: "Celebrate with the best ride!" },
];

const InspirationCard = () => {
  return (
    <div className="VehicleSlider-container1 container">
      <Swiper
        spaceBetween={20}
        slidesPerView={1}
        breakpoints={{
          640: { slidesPerView: 2 },
          1024: { slidesPerView: 3 },
          1280: { slidesPerView: 4 },
        }}
        navigation={{
          nextEl: ".swiper-button-next1",
          prevEl: ".swiper-button-prev1",
        }}
        autoplay={{ delay: 2500, disableOnInteraction: false }}
        loop={true} 
       
        grabCursor={true}
        modules={[Navigation, Autoplay]}
      >
        {vehicleData.map((vehicle, index) => (
          <SwiperSlide key={index}>
            <div className="vehicle-card">
              <img src={vehicle.img} alt={vehicle.title} className="vehicle-img" />
              <div className="vehicle-info">
                <h3>{vehicle.title}</h3>
                <p>{vehicle.description}</p>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
      <div className="swiper-button-prev1 "></div>
          <div className="swiper-button-next1 "></div>
    </div>
  );
};

export default InspirationCard;
